enum AuthProviderEnum {
  GOOGLE = 'google',
  TWITTER = 'twitter',
  TELEGRAM = 'telegram',
  DEFAULT = 'default',
}

export { AuthProviderEnum };
